// extracted by mini-css-extract-plugin
export default {"scene":"GamesWheel__scene--1_3","wheel":"GamesWheel__wheel--1nR","text":"GamesWheel__text--B80","wheelFace":"GamesWheel__wheelFace--EhB","active":"GamesWheel__active--3AU"};